import { TabLines } from '@design/components/tab-lines/TabLines';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './InsightFeedTypeTabLine.module.scss';

export type InsightFeedFilterTabs =
  | 'all'
  | 'company_catalyst'
  | 'market_catalyst'
  | 'scenarios'
  | 'earnings'
  | 'summaries';

interface InsightFeedTypeTabLineProps {
  selectedTabType: InsightFeedFilterTabs;
  isMarketPage?: boolean;
  onTabChange: (tabType: InsightFeedFilterTabs) => void;
}

export const marketTabKeys: InsightFeedFilterTabs[] = [
  'all',
  'company_catalyst',
  'market_catalyst',
  'scenarios',
  'earnings',
  'summaries',
];

export type FollowingInsightFeedFilterTabs =
  | 'all'
  | 'company_catalyst'
  | 'scenarios'
  | 'earnings';

export const followingTabKeys: FollowingInsightFeedFilterTabs[] = [
  'all',
  'company_catalyst',
  'scenarios',
  'earnings',
];

export const InsightFeedTypeTabLine = ({
  selectedTabType,
  isMarketPage = false,
  onTabChange,
}: InsightFeedTypeTabLineProps) => {
  const { t } = useTranslation(['stream']);

  const tabs: Record<InsightFeedFilterTabs, string> = {
    all: t('stream:insightFeedTypeTabs.all'),
    company_catalyst: t('stream:insightFeedTypeTabs.companyCatalysts'),
    market_catalyst: t('stream:insightFeedTypeTabs.marketCatalysts'),
    scenarios: t('stream:insightFeedTypeTabs.scenario'),
    earnings: t('stream:insightFeedTypeTabs.earnings'),
    summaries: t('stream:insightFeedTypeTabs.summaries'),
  };

  const isInsightFeedFilterTab = (key: string) => {
    return (
      key === 'all' ||
      key === 'company_catalyst' ||
      key === 'market_catalyst' ||
      key === 'scenarios' ||
      key === 'earnings' ||
      key === 'summaries'
    );
  };

  const handleChange = (_index: number, tabKey: string) => {
    if (isInsightFeedFilterTab(tabKey)) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      onTabChange(tabKey as InsightFeedFilterTabs);
    }
  };

  const tabKeys = isMarketPage ? marketTabKeys : followingTabKeys;
  return (
    <TabLines
      className={styles.tabLines}
      activeTab={selectedTabType}
      onChange={handleChange}
      tabs={tabKeys.map(key => ({
        tabKey: key,
        tabLabel: tabs[key],
      }))}
    />
  );
};
